import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MonitoringAccountConfigurationApi } from '../../api/monitoring/monitoring-account-configuration.api';
import { MonitorConfigService } from './services/monitor-config.service';
import { MonitorReportsNavigationService } from './services/monitor-reports-navigation.service';
import { ManageTemplateDialogComponent } from './components/ManageTemplateDialog/manage-template-dialog.component';
import { BriefingTemplateService } from './services/briefing-template.service';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { MiscModule } from '../Misc/misc.module';
import { TakeOverModule } from '../TakeOver/take-over.module';
import { BriefingConfigService } from './services/briefing-config.service';
import { BriefingConfigApiService } from '../../api/monitoring/briefing-config.api.service';
import { CachedDateService } from './services/cached-date.service';

@NgModule({
    declarations: [
        ManageTemplateDialogComponent
    ],
    exports: [
        ManageTemplateDialogComponent
    ],
    providers: [
        MonitorReportsNavigationService,
        MonitorConfigService,
        BriefingConfigService,
        MonitoringAccountConfigurationApi,
        BriefingConfigApiService,
        BriefingTemplateService,
        {
            provide: 'BriefingTemplateService',
            useExisting: BriefingTemplateService
        },
        CachedDateService
    ],
    imports: [
        CoreDialogsModule,
        CommonFormsModule,
        LocalizationModule,
        FormsModule,
        MiscModule,
        TakeOverModule
    ]
})
export class CommonMonitorSharedModule { }
